<template>
  <div
    :style="`${bgColor ? `background-color: ${bgColor}; color: white;` : 'border: 1px solid #B3B3B3;'};`"
    style="width: 100%; text-align: center; padding: 8px 0; border-radius: 8px;"
  >
    <div style="font-weight: 600;">{{ name }}</div>
    <div style="margin: 5px 0; font-size: 20px; font-weight: 600;">
      {{ numberFormat({ number: infos.amount, style: 'currency', currency: infos.currency, notation: 'compact' }) }}
    </div>
    <div style="font-size: 16px; font-weight: 400;">
      {{ $tc('leadWeekly.block.leads', infos.dealers > 1, { count: infos.dealers }) }}
    </div>
  </div>
</template>

<script>
import { numberFormat } from '@/utils/formatters.util'

export default {
  name: 'LpeReportBlock',
  props: {
    infos: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      numberFormat,
    }
  },
}
</script>
